module.exports = __webpack_public_path__ + "static/media/cross.7023c05f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/socialMedia/cross.svg
// module id = 2314
// module chunks = 0